import { Component } from '@angular/core';

@Component({
  selector: 'app-tracto-no-selected',
  templateUrl: './tracto-no-selected.component.html',
  styleUrls: ['./tracto-no-selected.component.css'],
})
export class TractoNoSelectedComponent {}
